
// # 付きのアンカーリンクだった場合、クリック時にメニュー閉じる
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('MenuDrawer');
  if (!drawer) return;

  const drawerLinks = drawer.querySelectorAll('a[href^="#"]');
  drawerLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      // メニューを閉じる処理（active属性を外す）
      drawer.removeAttribute('active');
      document.body.classList.remove('menu-open'); // スクロール制御用（必要に応じて）
      document.body.classList.remove('modal-showing');
      drawer.removeAttribute('open');
    });
  });

  // クローズボタン（×）が押されたときも modal-showin を削除
  const closeButton = document.querySelector('.drawer__close');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      document.body.classList.remove('modal-showing');
    });
  }

  // 余白（オーバーレイ）を押したらメニューを閉じる
  const overlay = drawer.querySelector('.side-menu-overlay');
  if (overlay) {
    overlay.addEventListener('click', function () {
      drawer.removeAttribute('open');
      drawer.removeAttribute('active');
      document.body.classList.remove('menu-open');
      document.body.classList.remove('modal-showing');
    });
  }
  
  
});

// お気に入りリスト変更
document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver((mutations, obs) => {
    const container = document.querySelector('#mxpr-favorites-container');
    if (container) {
      const heading = container.querySelector('h2');
      if (heading) {
        heading.textContent = 'お気に入り';
      }

      container.style.display = 'block'; // ← 強制表示
      obs.disconnect(); // 監視終了
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


// カートに入れるをクリックした後の挙動　
document.addEventListener('DOMContentLoaded', function() {
  let isUpdatingDelayed = false;
  let updateInProgress = false; // 更新処理中フラグを追加
  
  // ———— バッジの更新処理 ————
  function updateCartBadge(count) {
    const badge = document.querySelector('cart-count.cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.setAttribute('aria-label', count + ' 個の商品');
    badge.classList.add('badge--bump');
    setTimeout(() => badge.classList.remove('badge--bump'), 300);
    console.log('✅ バッジ更新: ' + count);
  }
  
  // ———— 遅延付きで非表示→fetch→再表示＋更新 ————
  function hideFetchShow(delay = 0, source = '') {
    // 既に更新処理中の場合はスキップ
    if (updateInProgress) {
      console.log('⏭️ 更新処理中のためスキップ (source:', source, ')');
      return Promise.resolve();
    }
    
    if (isUpdatingDelayed) {
      console.log('⏭️ 遅延更新中のためスキップ (source:', source, ')');
      return Promise.resolve();
    }
    
    updateInProgress = true;
    isUpdatingDelayed = true;
    console.log('🔄 更新処理開始 (source:', source, ', delay:', delay, ')');
    
    const badge = document.querySelector('cart-count.cart-count');
    if (!badge) {
      return Promise.resolve().finally(() => {
        isUpdatingDelayed = false;
        updateInProgress = false;
      });
    }
    
    // 1) 非表示
    badge.style.visibility = 'hidden';
    
    // 2) delay 後に fetch → 更新 → 表示
    return new Promise(resolve => {
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => {
            if (!res.ok) throw new Error('カート取得失敗:'+res.status);
            return res.json();
          })
          .then(cart => {
            updateCartBadge(cart.item_count);
            // 3) 再表示
            badge.style.visibility = 'visible';
          })
          .catch(err => {
            console.error(err);
            // エラー時も表示だけは戻す
            badge.style.visibility = 'visible';
          })
          .finally(() => {
            isUpdatingDelayed = false;
            updateInProgress = false;
            console.log('✅ 更新処理完了 (source:', source, ')');
            resolve();
          });
      }, delay);
    });
  }
  
  // ———— fetch APIのインターセプト ————
  const originalFetch = window.fetch;
  
  // 複数のAPI呼び出しをまとめるための変数
  let cartAPICallTimer = null;
  let pendingAPICall = null; // 保留中のAPI呼び出し情報
  let badgeHiddenTime = 0;
  
  window.fetch = function(...args) {
    const url = args[0];
    
    // カート関連のAPIコールを検知
    if (typeof url === 'string' && url.includes('/cart/') && !url.includes('/cart/update')) {
      console.log('📡 カートAPI呼び出し検知:', url);
      
      // 前のタイマーを確実にクリア
      if (cartAPICallTimer) {
        clearTimeout(cartAPICallTimer);
        cartAPICallTimer = null;
        console.log('⏹️ 前のタイマーをクリア');
      }
      
      // バッジを非表示（1秒以上経過していたら）
      const badge = document.querySelector('cart-count.cart-count');
      const now = Date.now();
      if (badge && (now - badgeHiddenTime > 1000)) {
        badge.style.visibility = 'hidden';
        badgeHiddenTime = now;
      }
      
      return originalFetch.apply(this, args).then(response => {
        // カート更新系のAPIコールの場合
        if (url.includes('/cart/add') || 
            url.includes('/cart/change')) {
          
          // API呼び出し情報を保存
          pendingAPICall = {
            url: url,
            time: Date.now()
          };
          
          // 新しいタイマーを設定
          cartAPICallTimer = setTimeout(() => {
            if (!pendingAPICall) return;
            
            const finalUrl = pendingAPICall.url;
            console.log("📊 カートAPI処理を実行:", finalUrl);
            
            // URLによって遅延時間を調整
            let delay = 1500; // デフォルト
            let source = 'api';

            if (finalUrl.includes("/cart/add")) {
              source = 'add';
              delay = window.location.pathname.includes("/products/") ? 1500 : 1500;
            } else if (finalUrl.includes("/cart/change")) {
              source = 'change';
              if (finalUrl.includes("quantity=0")) {
                delay = 2000;
              }
            }
            
            // タイマーとAPI情報をクリア
            cartAPICallTimer = null;
            pendingAPICall = null;
            
            // 遅延実行
            hideFetchShow(delay, source);
          }, 500); // 500msに延長して、より確実にまとめる
        }
        return response;
      });
    }
    
    return originalFetch.apply(this, args);
  };
  
  // ———— 商品ページのボタンテキスト変更（オプション） ————
  const btnSelectors = [
    '#ProductSubmitButton-template--24952059592990__main',
    '#ProductSubmitButton-template--24680665284894__main'
  ];
  
  btnSelectors.forEach(selector => {
    const btn = document.querySelector(selector);
    const span = btn ? btn.querySelector('span') : null;
    
    if (btn && span) {
      const originalText = span.textContent;
      btn.addEventListener('click', function() {
        const form = this.closest('form');
        if (!form) return;
        
        form.addEventListener('submit', function() {
          setTimeout(() => {
            span.textContent = 'カートに追加されました';
            setTimeout(() => { 
              span.textContent = originalText; 
            }, 3200);
          }, 800);
        }, { once: true });
      });
    }
  });
});

// MR.POINT バリエーション切り替え対応（変更なし）
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 MR.POINT URL監視スクリプト開始');
  console.log('現在のURL:', window.location.href);
  
  let lastVariantId = null;
  let lastURL = window.location.href;
  
  // URLからバリエーションIDを取得
  function getVariantIdFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    console.log('URLパラメータチェック:', {
      fullURL: window.location.href,
      search: window.location.search,
      variantId: variantId
    });
    return variantId;
  }
  
  // MR.POINTを更新
  function updateMRPoint(variantId) {
    if (variantId && variantId !== lastVariantId) {
      lastVariantId = variantId;
      console.log('🔄 MR.POINT更新実行: バリエーションID =', variantId);
      
      document.dispatchEvent(new CustomEvent("mrpoint:update-award-point", {
        detail: {
          variantId: parseInt(variantId, 10),
        }
      }));
    } else {
      console.log('⏭️ 更新スキップ:', {
        variantId: variantId,
        lastVariantId: lastVariantId,
        同じID: variantId === lastVariantId
      });
    }
  }
  
  // URL変更を検知する関数
  function checkURLChange() {
    const currentURL = window.location.href;
    if (currentURL !== lastURL) {
      console.log('📍 URL変更検知:', {
        前のURL: lastURL,
        新しいURL: currentURL
      });
      lastURL = currentURL;
      
      const variantId = getVariantIdFromURL();
      if (variantId) {
        updateMRPoint(variantId);
      }
    }
  }
  
  // 初回実行
  const initialVariantId = getVariantIdFromURL();
  if (initialVariantId) {
    console.log('📌 初回バリエーションID:', initialVariantId);
    updateMRPoint(initialVariantId);
  } else {
    console.log('⚠️ 初回バリエーションIDが見つかりません');
  }
  
  // 方法1: MutationObserverでURL変更を監視
  const urlObserver = new MutationObserver(() => {
    checkURLChange();
  });
  
  // body全体を監視（URL変更時にDOMも変わることが多いため）
  urlObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href']
  });
  
  // 方法2: 定期的にURLをチェック（フォールバック）
  setInterval(checkURLChange, 500);
  
  // 方法3: History APIのインターセプト（改良版）
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  
  history.pushState = function(...args) {
    console.log('🔀 pushState呼び出し検知');
    originalPushState.apply(history, args);
    // 少し遅延を入れてURLが確実に変更されてから実行
    setTimeout(checkURLChange, 10);
  };
  
  history.replaceState = function(...args) {
    console.log('🔄 replaceState呼び出し検知');
    originalReplaceState.apply(history, args);
    setTimeout(checkURLChange, 10);
  };
  
  // 方法4: popstateイベント
  window.addEventListener('popstate', function(e) {
    console.log('⬅️ popstateイベント検知');
    setTimeout(checkURLChange, 10);
  });
  
  // 方法5: バリエーション選択の要素を監視（フォールバック）
  document.addEventListener('click', function(e) {
    // バリエーション選択に関連しそうな要素のクリックを検知
    const target = e.target;
    const isVariantRelated = 
      target.closest('[data-variant-id]') ||
      target.closest('[data-option-value]') ||
      target.closest('.variant-input') ||
      target.closest('label[for*="variant"]') ||
      target.closest('input[name="id"]') ||
      target.closest('select[name="id"]');
    
    if (isVariantRelated) {
      console.log('🖱️ バリエーション関連要素のクリック検知:', target);
      // クリック後、少し待ってからURL変更をチェック
      setTimeout(checkURLChange, 100);
      setTimeout(checkURLChange, 500);
      setTimeout(checkURLChange, 1000);
    }
  }, true);
  
  // 方法6: フォーム要素の変更を監視
  document.addEventListener('change', function(e) {
    const target = e.target;
    if (target.name === 'id' || target.getAttribute('data-variant-select')) {
      console.log('📝 フォーム変更検知:', target);
      setTimeout(checkURLChange, 100);
      setTimeout(checkURLChange, 500);
    }
  }, true);
  
  // MR.POINTイベントの受信確認
  document.addEventListener('mrpoint:update-award-point', function(e) {
    console.log('✅ MR.POINTイベント送信完了:', e.detail);
  });
  
  // デバッグ用: 現在の状態を確認するグローバル関数
  window.debugMRPoint = function() {
    console.log('🔍 デバッグ情報:', {
      現在のURL: window.location.href,
      現在のバリエーションID: getVariantIdFromURL(),
      最後に記録したバリエーションID: lastVariantId,
      最後に記録したURL: lastURL
    });
  };
  
  console.log('💡 ヒント: コンソールで debugMRPoint() を実行すると現在の状態を確認できます');
});